import { render, staticRenderFns } from "./BoardV2.vue?vue&type=template&id=7cb6f418"
import script from "./BoardV2.vue?vue&type=script&lang=js"
export * from "./BoardV2.vue?vue&type=script&lang=js"
import style0 from "./mx.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports